import React, {useContext} from 'react';
import clsx from "clsx";
import {Card, CardContent, CardHeader, Typography} from "@mui/material";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import AnagraficaCard from "../details/AnagraficaCard";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {AnagraficaContext} from "../../../../App";
import {useTheme} from "@mui/styles";

const SearchCardResult = ({
	                          open,
	                          loadingSearch,
	                          anagraficheSearch,
	                          errorSearch,
	                          lastTicketElementRef,
	                          onClickDetail,
	                          color = false
                          }) => {
	const anagraficaContext = useContext(AnagraficaContext);
	
	const classes = BaseStyle();
	let theme = useTheme();
	
	return (
        <Card className={clsx(classes.roundBorder)}
		      style={{
			      height: "100%",
			      display: "flex",
			      flexDirection: "column",
			      backgroundColor: color ? theme.palette.mode === "light" ? "aliceblue" : "darkcyan" : theme.palette.background.paper
		      }}>
            <CardHeader
				title={<Typography variant={"h6"}><b>Risultati ricerca</b></Typography>}
				subheader={"Una volta cercata un' anagrafica vedrai comparire tutti i risultati che combaciano qui."}
			/>
            <CardContent style={{flexGrow: 1, maxHeight: 800, overflowY: "auto", paddingBottom: 20}}>
				{
					!open && !loadingSearch && anagraficheSearch.length === 0 &&
					<Alert severity="info" style={{borderRadius: 24}}>
						<AlertTitle><b>Nessuna corrispondenza</b></AlertTitle>
						Non ci sono anagrafiche che corrispondono a quanto cercato o non hai ancora iniziato la ricerca
					</Alert>
				}
				{
					!open && !loadingSearch && errorSearch &&
					<Alert severity="error" style={{borderRadius: 24}}>
						<AlertTitle><b>Errore</b></AlertTitle>
						Qualcosa è andato storto, ricarica la pagina e se l' errore persiste contatta uno sviluppatore
					</Alert>
				}
				
				{
					open && !anagraficaContext.state.loadingSearchAnagrafica && anagraficaContext.state.searchedAnagrafica.length === 0 &&
					<Alert severity="info" style={{borderRadius: 24}}>
						<AlertTitle><b>Nessuna corrispondenza</b></AlertTitle>
						Non ci sono anagrafiche che corrispondono a quanto cercato o non hai ancora iniziato la ricerca
					</Alert>
				}
				{
					open && !anagraficaContext.state.loadingSearchAnagrafica && anagraficaContext.state.errorSearchAnagrafica !== "" &&
					< Alert severity="error" style={{borderRadius: 24}}>
						<AlertTitle><b>Errore</b></AlertTitle>
						Qualcosa è andato storto, ricarica la pagina e se l' errore persiste contatta uno sviluppatore
					</Alert>
				}
				
				{
					(open ? anagraficaContext.state.searchedAnagrafica : anagraficheSearch).map((anagrafica, index) => {
						if ((open ? anagraficaContext.state.searchedAnagrafica : anagraficheSearch).length === index + 1) {
							return (
								<Card ref={lastTicketElementRef} key={anagrafica.idSoggetto}
								      className={clsx(classes.roundBorder, classes.mailCard)}>
									<AnagraficaCard anagrafica={anagrafica} onClickDetail={onClickDetail}/>
								</Card>
							)
						} else {
							return (
								<Card key={anagrafica.idSoggetto}
								      className={clsx(classes.roundBorder, classes.mailCard)}>
									<AnagraficaCard anagrafica={anagrafica} onClickDetail={onClickDetail}/>
								</Card>
							)
						}
					})
				}
				
				{
					loadingSearch &&
					<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
						<CardHeader
							avatar={<Skeleton variant="circular" height={40} width={40}/>}
							title={<Skeleton width={180}/>}
							subheader={<Skeleton width={260}/>}
							action={<Skeleton variant="circular" height={20} width={20}/>}
							style={{paddingBottom: 2}}
						/>
						<CardContent style={{paddingTop: 0, marginTop: -35}}>
							<Skeleton height={200}/>
						</CardContent>
					</Card>
				}
				{
					open && anagraficaContext.state.loadingSearchAnagrafica &&
					<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
						<CardHeader
							avatar={<Skeleton variant="circular" height={40} width={40}/>}
							title={<Skeleton width={180}/>}
							subheader={<Skeleton width={260}/>}
							action={<Skeleton variant="circular" height={20} width={20}/>}
							style={{paddingBottom: 2}}
						/>
						<CardContent style={{paddingTop: 0, marginTop: -35}}>
							<Skeleton height={200}/>
						</CardContent>
					</Card>
				}
			</CardContent>
        </Card>
    );
};

export default React.memo(SearchCardResult);
